import { CommonServices } from "../../services";
import checkVersionResult from "./check-version-result";

interface IVersionModel {
    webApiEndPoint: String
    webAppEndPoint: String
    webApiVersion: String
    webAppVersion: String
}

class VersionModel {
    webApiEndPoint: String
    webAppEndPoint: String
    webApiVersion: String
    webAppVersion: String
}

class CheckVersionResult {
    state: number;
    currentVersion: IVersionModel;
    serviceVersion: IVersionModel;
    constructor() {
        this.state = checkVersionResult.success;
    }
}

export class CheckVersionRequest {
    currentVersion: IVersionModel;
    serviceVersion: IVersionModel;
}

export interface IVersionReader {
    getVersion() : Promise<IVersionModel>;
}

export class LocalStorageVersionReader implements IVersionReader {
    getVersion() : Promise<IVersionModel> {
        let authJson = localStorage.getItem("AuthorizationData")
        if(!authJson) return null;

        let auth = JSON.parse(authJson);
        if(!auth) return null;

        let version = new VersionModel();
        version.webApiVersion = auth.webApiVersion;
        version.webAppVersion = auth.webAppVersion;
        version.webAppEndPoint = auth.webAppEndPoint;
        version.webApiEndPoint = auth.webApiEndPoint;
        return Promise.resolve(version);
    }
}

export class ServiceVersionReader implements IVersionReader {
    service: CommonServices
    constructor() {
        this.service = new CommonServices();
    }

    get enviroment(): string {
        let authJson = localStorage.getItem("AuthorizationData")
        if(!authJson) return null;

        let auth = JSON.parse(authJson);
        if(!auth) return null;
        return auth.environment
    }

    async getVersion(environment?: any): Promise<IVersionModel> {
        let env = this.enviroment;
        if (environment) {
            env = environment;
        }
        return await this.service.getCurrentVersion(env).then(response =>{
            if(!response) return Promise.reject(response)

            let version = new VersionModel();
            version.webApiVersion = response.Api;
            version.webAppVersion = response.App;
            return Promise.resolve(version); 
        })
    }
}
export class QueryURLVersionReader implements IVersionReader {
    constructor() {
    }

    getAuthorizationData(){
        let authJson = localStorage.getItem("AuthorizationData")
        if(!authJson) return null;
        let auth = JSON.parse(authJson);
        return auth
    }
    async getVersion() : Promise<IVersionModel> {
        let pathname = window.location.pathname;
        let auth = this.getAuthorizationData();
        var environmentPattern = auth.environment,
        re = new RegExp(environmentPattern, "g");
        let webAppVersion = pathname.replace(/[/]/g, "").replace(re, "");
        let version = new VersionModel();
        version.webAppEndPoint = window.location.hostname;
        version.webAppVersion = webAppVersion;
        return Promise.resolve(version);

    }
}

export class VersionHelper {
    static async checkVersion() : Promise<CheckVersionResult>{
        var currentVersionStored =  new LocalStorageVersionReader();
        var serviceVersionStored =  new ServiceVersionReader();
        var queryURLVersionStored = new QueryURLVersionReader();

        var currentVersion = await currentVersionStored.getVersion()
        var serviceVersion = await serviceVersionStored.getVersion();
        var queryVersion = await queryURLVersionStored.getVersion();

        var result = new CheckVersionResult();
        result.currentVersion = currentVersion;
        result.serviceVersion = serviceVersion;
        if(result.state == checkVersionResult.success && currentVersion.webApiVersion != serviceVersion.webApiVersion){
            result.state = checkVersionResult.confictApiVersion;
        }
        if(result.state == checkVersionResult.success && currentVersion.webAppVersion != serviceVersion.webAppVersion){
            result.state = checkVersionResult.confictWebAppVersion;
        }
        if(result.state == checkVersionResult.success && queryVersion.webAppVersion != serviceVersion.webAppVersion){
            result.state = checkVersionResult.confictWebAppVersion;
        }
        return Promise.resolve(result);
    }
}